// extracted by mini-css-extract-plugin
export default {"header":"header_6d9qR","header_right":"header_right_1ycZ_"};